import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { formatPriceNumber } from "@/utils/formatPriceNumber";
import { useT } from "@transifex/react";
import type React from "react";

interface TransactionDetailsProps {
  subtotal: number;
  convenienceFee: number;
  tax: number;
  discount: number | null;
  rateName: string;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = ({ rateName, subtotal, convenienceFee, tax, discount }) => {
  const t = useT();
  const makeRow = (title: string, value: number, color = "text-typography-900", signal = "") => (
    <HStack className="justify-between">
      <Text className={`font-[600] leading-[22px] text-[16px] ${color}`}>{title}:</Text>
      <Text className={`font-[600] leading-[22px] text-[16px] ${color}`}>
        {signal}${formatPriceNumber(value)}
      </Text>
    </HStack>
  );

  return (
    <VStack className="gap-[12px]">
      {makeRow(rateName, subtotal)}
      {convenienceFee > 0 && makeRow(t("Convenience Fee"), convenienceFee)}
      {tax > 0 && makeRow(t("Taxes"), tax)}
      {(discount ?? 0) > 0 && makeRow(t("Discount"), discount ?? 0, "text-success-700", "-")}
    </VStack>
  );
};
